import type { Option } from '@usealloy/component-library';
import type { MatrixModel, OutputValueRange, ValueRangeConfigOptions } from '../../../store/engine/types';
import type { Axis } from '../../../editor/components/NodeEditorDrawer/MatrixModel/AxisHeaderDropdown';

export enum DimensionsTypeChange {
  'CHANGE_TO_2D',
  'CHANGE_TO_1D',
  'NO_CHANGE',
}

export enum DataTypeChange {
  'CHANGE_TO_STRING',
  'CHANGE_TO_NUMBER',
  'NO_CHANGE',
}

export type FormState = {
  name: string;
  dataTypeOption: Option;
  dimensionsOption: Option;
  description: string;
  defineValueRanges?: boolean;
  outputValueRange?: OutputValueRange[];
  outputValueRangeOptions?: ValueRangeConfigOptions;
};

export enum MatrixDataType {
  'STRING' = 'string',
  'NUMBER' = 'number',
}

export enum MatrixAxisDataType {
  'STRING' = 'string',
  'NUMBER' = 'number',
}

export enum MatrixAxisOrder {
  'ASC' = 'asc',
  'DESC' = 'desc',
}

export enum MatrixAxisOperation {
  'ADD',
  'DELETE',
}

export enum HighRangeOption {
  bounded = 'bounded', unbounded = 'unbounded',
}

export enum LowRangeOption {
  bounded = 'bounded', unbounded = 'unbounded',
}

export interface UpdateMatrixSizeProps {
  axis: Axis;
  matrix: MatrixModel['matrix'];
  op: MatrixAxisOperation;
  count?: number;
  row?: number;
}

export type MatrixDimensions = 1 | 2;
